const _isAllowedCharacterChecker = function (c: string): boolean {
	return (c >= "a" && c <= "z")
		|| (c >= "A" && c <= "Z")
		|| (c >= "0" && c <= "9");
};

function isValid(environmentName: string): boolean {
	return typeof environmentName === "string"
		&& environmentName !== ""
		&& environmentName.split("")
			.every(
				_isAllowedCharacterChecker
			);
}

export {
	isValid
};
